"use client";

import { useEffect } from "react";

/**
 * Ctrl/Cmd+K opens global search.
 *
 * Suppressed while `disabled` (a guided tour is running): the tour binds bare
 * ArrowLeft/ArrowRight and Escape on document, so a palette open underneath it
 * would fight the tour for every keystroke.
 */
export function useSearchShortcut(onOpen: () => void, disabled = false) {
  useEffect(() => {
    if (disabled) return;
    function onKeyDown(e: KeyboardEvent) {
      if (e.key.toLowerCase() !== "k" || !(e.metaKey || e.ctrlKey) || e.altKey) return;
      e.preventDefault();
      onOpen();
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onOpen, disabled]);
}
